/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
export default function generator(_ref) {
  var borders = _ref.borders,
      colors = _ref.colors,
      breakpoints = _ref.breakpoints,
      stacking = _ref.stacking;
  return {
    defaultBackground: colors.backgroundLightest,
    scrollFadeColor: colors.backgroundLightest,
    tabVerticalOffset: borders.widthSmall,
    // gives effect of selected tab "bar" overlaying bottom border
    zIndex: stacking.above,
    small: breakpoints.small,
    medium: breakpoints.medium,
    large: breakpoints.large,
    scrollOverlayWidthDefault: '5rem'
    /* 4 times the padding of a default Tab. If Tab padding changes, update this value. */
    ,
    scrollOverlayWidthSecondary: '3rem'
    /* 3 times the padding of a secondary Tab. If Tab padding changes, update this value. */

  };
}